import { Snackbar } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Collection } from "@type-r/models";
import { useLinked } from "@type-r/react";
import { Columns, TilesList } from "lqx-react";
import React from "react";
import { DetailsPaneColumn, TilesListColumn } from "../components/item-card-styles";
import { PopupActionDialog } from "../components/popups/popup-action-dialog";
import { ValidationRulesCardRenderer } from "./validation-rules-card-renderer";
import { ValidationRulesDetailsPane } from "./validation-rules-details-pane";
import { ValidationRuleItem } from "../api/validationRuleItem";

export const ValidationRulesList = ({ validationCards }: { validationCards: Collection<ValidationRuleItem> }) => {
  const $activeCard = useLinked<ValidationRuleItem>(null);
  const defaultContext = { onApply: null, onCancel: null, actionType: '', actionText: '', isPopupOpen: false };
  const $popupContext = useLinked<{
    onApply: any,
    onCancel: any,
    actionType: String,
    actionText: String,
    isPopupOpen: boolean
  }>(defaultContext);
  const $showAlertMessage = useLinked<boolean>(false);
  const $errorMessage = useLinked("");

  const handleCloseShowErrors = (_, reason) => {
    if (reason === 'clickaway') return;
    $showAlertMessage.set(false);
  };

  const onCancel = () => $popupContext.set(defaultContext);

  const onApply = async (id) => {
    $activeCard.set(null);
    $popupContext.set(defaultContext);
    await validationCards.find(i => i.id === id)
      .delete()
      .then(id => validationCards.remove(id))
      .catch(e => $errorMessage.set(e.message));
    $showAlertMessage.set(true);
  }

  const onDelete = (id) => {
    if (id) {
      $popupContext.set({
        onApply: () => onApply(id),
        onCancel: () => onCancel(),
        actionType: 'Delete',
        actionText: 'Are you sure you want to Delete this Validation Set?',
        isPopupOpen: true
      });
    }
  }

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={$showAlertMessage.value}
        autoHideDuration={6000}
        onClose={handleCloseShowErrors}>
        {$errorMessage.value.length > 0 ?
          <Alert severity="error">
            <AlertTitle>Error during deletion of Validation Set</AlertTitle>
            {$errorMessage.value}
          </Alert> :
          <Alert severity="success">
            <AlertTitle>Successfuly deleted</AlertTitle>
          </Alert>
        }
      </Snackbar>
      <Columns style={{ height: 'calc(100% - 80px)' }}>
        <TilesListColumn>
          <TilesList
            items={validationCards.models}
            itemSize={100}
            renderer={ValidationRulesCardRenderer($activeCard, onDelete)}
          />
        </TilesListColumn>
        {$activeCard.value &&
          <DetailsPaneColumn>
            <ValidationRulesDetailsPane $activeCard={$activeCard} onDelete={onDelete} />
          </DetailsPaneColumn>}
      </Columns>
      <PopupActionDialog $context={$popupContext} />
    </>
  );
};
